import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { TipoOperacaoCreditoModel } from "../model/tipo-operacao-credito.model";

@Injectable()
export class TipoOperacaoCreditoService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * TipoOperacao Crédito por id
     * @param id ID da TipoOperacao Crédito
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "credito/tipo-operacao/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de TipoOperacao Crédito
     * @param id ID da TipoOperacao Crédito
     */
    getAll(
        params: Record<string, unknown>
    ): Observable<ApiPaginationResponseDataNonNullable<TipoOperacaoCreditoModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<TipoOperacaoCreditoModel>>(
            this.utilitesService.urlPrefix + "credito/tipo-operacao" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Lista de TipoOperacao Crédito
     * @param id ID da TipoOperacao Crédito
     */
    search(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "credito/tipo-operacao/search" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de TipoOperacao Crédito
     * @param id ID da TipoOperacao Crédito
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "credito/tipo-operacao/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra TipoOperacao Crédito
     * @param params Json TipoOperacao Crédito
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "credito/tipo-operacao", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza TipoOperacao Crédito
     * @param params Json TipoOperacao Crédito
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(this.utilitesService.urlPrefix + "credito/tipo-operacao/" + id, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
